module.exports = __webpack_public_path__ + "assets/iphone.e021b9cfad0978b9fe906a00f8264e3f8349afed833733c83a27aadfcfbb9820.png";